import * as types from "./types";

const initialState = {
  page: 1,
  rowCount: 10,
};

const persistReport = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_REPORT_PAGE:
      return {
        ...state,
        page: action.payload,
      };

    case types.SET_REPORT_ROW:
      return {
        ...state,
        rowCount: action.payload,
      };

    default:
      return state;
  }
};
export default persistReport;
